import { fmtMoney } from '../lib/money'
import type { Currency } from '../lib/api/types'

// Renders a monetary value with the amount on the first line and the currency
// code stacked beneath it. Used in table cells so a long amount never wraps
// mid-number and the currency lands in a predictable spot — every money column
// looks the same regardless of magnitude. Right-aligned by default to match
// `.num` columns; pass align="left" for left-aligned contexts.
//
// We format via fmtMoney and split off the trailing currency token: fmtMoney
// always emits a single space before the 3-letter ISO code, and the code never
// contains spaces, so the last space is an unambiguous boundary.
export function Money({
  amount,
  currency,
  sign = false,
  align = 'right',
}: {
  amount: number
  currency: Currency
  sign?: boolean
  align?: 'right' | 'left'
}) {
  const full = fmtMoney(amount, currency, { sign })
  const split = full.lastIndexOf(' ')
  const amountPart = full.slice(0, split)
  const currencyPart = full.slice(split + 1)
  return (
    <span className={`money money--${align}`}>
      <span className="money__amt">{amountPart}</span>
      <span className="money__cur">{currencyPart}</span>
    </span>
  )
}
